const version = {
    code:'1.0.39',
}

export default version



// WEBPACK FOOTER //
// ./src/version.js